// ignore-string-externalization
import {
  createBaseTransport,
  TransportEvent,
  Endpoints,
} from '@spotify-internal/transport';
import { tokenProvider } from '@mrkt/features/auth';
import { anonymousAccessTokenManager } from '@mrkt/features/webgate-fetch';

export function createNonAuthTransport() {
  const transport = createBaseTransport({
    providers: {
      endpoints: () => {
        return Promise.resolve({
          webgate: 'https://generic.wg.spotify.com/',
        } as Endpoints);
      },
      token: () => anonymousAccessTokenManager.get() as any,
    },
  });

  if (process.env.NODE_ENV !== 'test') {
    transport.connect();
  }

  return transport;
}

export function createAuthTransport() {
  const transport = createBaseTransport({
    providers: {
      // default uses sp-client and we only allow generic.wg in our CSP headers
      endpoints: () => {
        return Promise.resolve({
          webgate: 'https://generic.wg.spotify.com/',
        } as Endpoints);
      },
      // TODO figure out the type for this
      token: () => tokenProvider() as any,
    },
  });

  transport.on(TransportEvent.CONNECTION_ONLINE, () => {
    transport.authenticate();
  });

  // failing in tests for some reason, need to fix
  if (process.env.NODE_ENV !== 'test') {
    transport.connect();
  }

  return transport;
}

export const transport = createAuthTransport();
export const nonAuthTransport = createNonAuthTransport();
